
import WidgetsIcon from '@mui/icons-material/Widgets';
import CropFreeIcon from '@mui/icons-material/CropFree';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

export const spRelationDetailsConfig = {
    details:  {
        title: 'details',
        icon: <CropFreeIcon/>,
    },
    relationContacts:  {
        title: 'contacts',
        icon: <WidgetsIcon/>,
        isSingleDataGrid: true,
        
    },
    stock:  {
        title: 'stock',
        icon: <WidgetsIcon/>,
    },
    palletspots:  {
        title: 'palletspots',
        icon: <WidgetsIcon/>,
    },
    settings:  {
        title: 'settings',
        icon: <WidgetsIcon/>,
    },
};
